/**
 * Environment-based configuration
 * API URL and tenant branding are resolved from the current domain.
 */

import { getTenantConfig } from './tenantConfig';

const getEnvironment = () => {
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'development';
    }
    return 'production';
  }

  return 'development';
};

const getApiUrl = () => {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }

  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }

  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${hostname}:3001`;
};

const currentEnv = getEnvironment();
const tenant = typeof window !== 'undefined' ? getTenantConfig() : null;

const currentConfig = {
  development: {
    apiUrl: 'http://localhost:3001',
    protocol: 'http',
    environment: 'development',
  },
  production: {
    apiUrl: getApiUrl(),
    protocol: window.location?.protocol === 'https:' ? 'https' : 'http',
    environment: 'production',
  },
}[currentEnv];

export const API_BASE_URL = currentConfig.apiUrl;
export const PROTOCOL = currentConfig.protocol;
export const ENVIRONMENT = currentConfig.environment;
export const TENANT_DISPLAY_NAME = tenant?.displayName || 'Al Mamzar Car Wash';

export const buildApiUrl = (endpoint) => {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

if (typeof window !== 'undefined') {
  console.log(`🔧 Environment: ${ENVIRONMENT}`);
  console.log(`🌐 API Base URL: ${API_BASE_URL}`);
  console.log(`🏢 Tenant: ${TENANT_DISPLAY_NAME}`);
}

export default currentConfig;
